import Swiper, {Pagination, Navigation} from 'swiper';

export class ElementorMobileCarouselComponent {
  container;

  config;

  swiper;

  constructor(selector, config) {
    this.container = document.querySelector(selector);
    this.config = config;
    this.swiper = null;
  }

  initialize() {
    if (!this.container || !this.config) {
      return;
    }

    this.initSwiper();
    this.addEventListeners();
  }

  initSwiper() {
    Swiper.use([Pagination, Navigation]);

    if (window.outerWidth < 768) {
      this.createCarousel();
    }
  }

  addEventListeners() {
    window.addEventListener('resize', (e) => this.windowResizeHandler(e));
  }

  windowResizeHandler(e) {
    window.outerWidth >= 768
      ? this.destroyCarousel()
      : this.createCarousel();
  }

  createCarousel() {
    if (this.swiper) {
      return;
    }

    const wrapper = this.container.querySelector('.elementor-container');
    if (!wrapper) {
      return;
    }

    this.container.classList.add('swiper-container');
    wrapper.classList.add('swiper-wrapper');

    const items = [...wrapper.children];
    items.forEach((item) => {
      item.classList.add('swiper-slide');
    });

    this.container.appendChild(this.createControlsContainer());

    this.swiper = new Swiper(this.container, this.config);
  }

  destroyCarousel() {
    const wrapper = this.container.querySelector('.elementor-container');
    if (!wrapper) {
      return;
    }

    this.container.classList.remove('swiper-container');
    wrapper.classList.remove('swiper-wrapper');

    const items = [...wrapper.children];
    items.forEach((item) => {
      item.classList.remove('swiper-slide');
    });

    this.destroyControlsContainer();

    if (this.swiper) {
      this.swiper.destroy();
    }

    this.swiper = null;
  }

  createControlsContainer() {
    const controls = document.createElement('div');
    controls.classList.add('swiper-controls-container');

    const pagination = this.createPaginationContainer();
    const navigation = this.createNavigationContainer();

    controls.appendChild(pagination);
    controls.appendChild(navigation);

    return controls;
  }

  destroyControlsContainer() {
    const controls = this.container.querySelector('.swiper-controls-container');
    if (controls) {
      controls.remove();
    }
  }

  createPaginationContainer() {
    const pagination = document.createElement('div');
    pagination.classList.add('swiper-pagination');

    return pagination;
  }

  createNavigationContainer() {
    const navigation = document.createElement('div');
    navigation.classList.add('swiper-navigation');

    const prev = document.createElement('div');
    prev.classList.add('swiper-button-prev');

    const next = document.createElement('div');
    next.classList.add('swiper-button-next');

    navigation.appendChild(prev);
    navigation.appendChild(next);

    return navigation;
  }
}